const isUserAnAdmin = user => {
  const ROLES = ['Admin', 'Sales', 'Support']
  const { roles } = user
  const userRoles = roles.data.map(role => role.name)
  const isAdmin = userRoles.some(role => ROLES.includes(role))
  return isAdmin
}

export default isUserAnAdmin
